import {
  ActionReducer,
  createReducer,
  on,
} from '@ngrx/store';
import {SharedLinkState} from '../shared-link.model';
import * as SharedLinkActions from '../shared-link.actions';

export const initialSharedLinkState: SharedLinkState = {
  sharedLinkId: null,
  sharedLinkData: null,
  isPreviewMode: false,
};

export const sharedLinkReducer: ActionReducer<SharedLinkState> = createReducer(
  initialSharedLinkState,
  on(SharedLinkActions.setSharedLinkId, (state, {id}) => ({...state, sharedLinkId: id})),
  on(SharedLinkActions.loadSharedLinkData, state => ({...state})),
  on(SharedLinkActions.loadSharedLinkDataSuccess, (state, {data}) => ({...state, sharedLinkData: data})),
  on(SharedLinkActions.loadSharedLinkDataFailure, state => ({...state})),
  on(SharedLinkActions.setPreviewModeActive, state => ({...state, isPreviewMode: true})),
  on(SharedLinkActions.setPreviewModeInactive, state => ({...state, isPreviewMode: false})),
  on(SharedLinkActions.clearSharedLinkData, state => ({...state, sharedLinkId: null, sharedLinkData: null})),
);
